
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as d2FzbTpqcy1zdHJpbmc from './sudoku-kmp-shared.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.io.printError' : (error) => console.error(error),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.JsArray_$external_class_instanceof' : (x) => x instanceof Array,
    'kotlin.js.JsArray_$external_class_get' : () => Array,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsNumber_$external_class_instanceof' : (x) => typeof x === 'number',
    'kotlin.js.JsNumber_$external_class_get' : () => JsNumber,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.Promise_$external_fun' : (p0) => new Promise(p0),
    'kotlin.js.__callJsClosure_((Js?)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__callJsClosure_((Js)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_2' : (f, trampoline) => getCachedJsObject(f, (p0, p1) => trampoline(f, p0, p1)),
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.promiseSetDeferred' : (promise, deferred) => promise.deferred = deferred,
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForUint8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0) => new Uint8Array(p0),
    'org.khronos.webgl.Uint8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.khronos.webgl.Uint8Array_$external_class_instanceof' : (x) => x instanceof Uint8Array,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.defaultPrevented_$external_prop_getter' : (_this) => _this.defaultPrevented,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.hostname_$external_prop_getter' : (_this) => _this.hostname,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.hash_$external_prop_getter' : (_this) => _this.hash,
    'org.w3c.dom.reload_$external_fun' : (_this, ) => _this.reload(),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.onmessage_$external_prop_setter' : (_this, v) => _this.onmessage = v,
    'org.w3c.dom.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
    'org.w3c.dom.postMessage_$external_fun' : (_this, p0, p1, isDefault0) => _this.postMessage(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.message_$external_prop_getter' : (_this) => _this.message,
    'org.w3c.dom.ErrorEvent_$external_class_instanceof' : (x) => x instanceof ErrorEvent,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.localStorage_$external_prop_getter' : (_this) => _this.localStorage,
    'org.w3c.dom.replaceState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.replaceState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.platform_$external_prop_getter' : (_this) => _this.platform,
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.StorageEvent_$external_class_instanceof' : (x) => x instanceof StorageEvent,
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.Storage_$external_class_instanceof' : (x) => x instanceof Storage,
    'org.w3c.dom.Storage_$external_class_get' : () => Storage,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'kotlinx.browser.sessionStorage_$external_prop_getter' : () => sessionStorage,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.isWasmExportsAvailable' : () => typeof wasmExports !== 'undefined',
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'androidx.datastore.core.okio.getArrayBufferFromBlob' : (blob) => blob.arrayBuffer(),
    'androidx.datastore.core.okio.getInt8' : (array, index) => array[index],
    'androidx.datastore.core.okio.setInt8' : (array, index, value) => array[index] = value,
    'androidx.datastore.core.okio.getWasmOpfsRoot' : () => window.navigator.storage.getDirectory(),
    'androidx.datastore.core.okio.getWasmNavigator' : () => navigator,
    'androidx.datastore.core.okio.createWritable_$external_fun' : (_this, ) => _this.createWritable(),
    'androidx.datastore.core.okio.getFile_$external_fun' : (_this, ) => _this.getFile(),
    'androidx.datastore.core.okio.getFileHandle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getFileHandle(p0, isDefault0 ? undefined : p1, ),
    'androidx.datastore.core.okio.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.datastore.core.okio.close_$external_fun' : (_this, ) => _this.close(),
    'androidx.datastore.core.okio.request_$external_fun' : (_this, p0, p1) => _this.request(p0, p1),
    'androidx.datastore.core.okio.request_$external_fun_1' : (_this, p0, p1, p2) => _this.request(p0, p1, p2),
    'androidx.datastore.core.okio.locks_$external_prop_getter' : (_this) => _this.locks,
    'androidx.datastore.core.okio.createCreateOptions' : () => ({create: true}),
    'androidx.datastore.core.okio.BroadcastChannel_$external_fun' : (p0) => new BroadcastChannel(p0),
    'androidx.datastore.core.okio.postMessage_$external_fun' : (_this, p0) => _this.postMessage(p0),
    'androidx.datastore.core.okio.close_$external_fun_1' : (_this, ) => _this.close(),
    'androidx.datastore.core.okio.onmessage_$external_prop_setter' : (_this, v) => _this.onmessage = v,
    'androidx.datastore.core.okio.tryLockOptions' : () => ({mode: 'exclusive', ifAvailable: true}),
    'co.touchlab.kermit.consoleError' : (output) => console.error(output),
    'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
    'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
    'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.material3.internal.getIs24HourFormat' : (localeTag) => {
                var locale = new Intl.Locale(localeTag);
                // Check for the hourCycles property first
                if (locale.hourCycles) {
                    return locale.hourCycles.includes('h23') || locale.hourCycles.includes('h24') ? 1 : 0;
                }

                // Fallback to hourCycle property
                if (locale.hourCycle) {
                    return locale.hourCycle === 'h23' || locale.hourCycle === 'h24' ? 1 : 0;
                }
                return -1;
            },
    'com.tvealot.styles.haptic.browserVibrate' : 
        (pattern) => {
            if (!navigator.vibrate) return false;
            const values = String(pattern).split(',').map((value) => Number(value));
            return navigator.vibrate(values.length === 1 ? values[0] : values);
        }
        ,
    'com.tvealot.styles.haptic.browserHapticsSupported' : () => typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function',
    'com.tvealot.styles.ui.theme.isIpadHomeScreenApp' : () => {
            const touchMac = /Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
            const ipad = /iPad/.test(navigator.userAgent) || (touchMac && Math.min(screen.width, screen.height) >= 744);
            const standalone = navigator.standalone === true || matchMedia('(display-mode: standalone)').matches;
            return ipad && standalone;
        },
    'com.tvealot.styles.ui.theme.observeSafeAreaChanges' : (onChange) => {
            const timers = [];
            const changed = () => {
                onChange();
                timers.splice(0).forEach(clearTimeout);
                for (const delay of [100, 500, 1000]) timers.push(setTimeout(onChange, delay));
            };
            addEventListener('resize', changed);
            addEventListener('orientationchange', changed);
            return () => {
                removeEventListener('resize', changed);
                removeEventListener('orientationchange', changed);
                timers.splice(0).forEach(clearTimeout);
            };
        },
    'com.tvealot.styles.ui.theme.readSafeAreaInset' : (property) => {
            const root = document.documentElement;
            if (!root.style.getPropertyValue('--alotoku-safe-top')) {
                for (const side of ['left', 'top', 'right', 'bottom']) {
                    root.style.setProperty('--alotoku-safe-' + side, 'env(safe-area-inset-' + side + ', 0px)');
                }
            }
            return parseFloat(getComputedStyle(root).getPropertyValue(property)) || 0;
        },
    'com.tvealot.styles.ui.theme.isLandscapeWindow' : () => innerWidth > innerHeight,
    'com.tvealot.sudoku.sharechallenge.platform.shareOrDownloadImage' : 
        (base64Png, fileName, caption) => {
            const binary = globalThis.atob(base64Png);
            const bytes = new Uint8Array(binary.length);
            for (let index = 0; index < binary.length; index += 1) {
                bytes[index] = binary.charCodeAt(index);
            }

            const download = () => {
                const blob = new Blob([bytes], { type: "image/png" });
                const url = URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = fileName || "sudoku-challenge.png";
                anchor.style.display = "none";
                document.body.appendChild(anchor);
                anchor.click();
                anchor.remove();
                URL.revokeObjectURL(url);

                if (caption && navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(caption).catch(() => {});
                }
            };

            const file = new File([bytes], fileName || "sudoku-challenge.png", { type: "image/png" });
            const sharePayload = {
                files: [file],
                title: "Sudoku challenge",
                text: caption,
            };

            if (navigator.share && (!navigator.canShare || navigator.canShare(sharePayload))) {
                navigator.share(sharePayload).catch(download);
                return;
            }

            download();
        }
        ,
    'com.arkivanov.mvikotlin.core.utils.internal.consoleError' : (text) => { console.error(text) },
    'com.tvealot.sudoku.analytics.installBrowserTelemetryHooks' : 
        (metric, crash, flush) => {
            if (globalThis.__alotokuTelemetryHooks) return;

            const timestamps = { crash: [], performance: [] };
            const limited = (kind, max) => {
                const now = Date.now();
                timestamps[kind] = timestamps[kind].filter((time) => now - time < 60000);
                if (timestamps[kind].length >= max) return true;
                timestamps[kind].push(now);
                return false;
            };
            const cleanText = (value, limit) => String(value || "")
                .replace(/https?:\/\/[^\s)]+/g, (url) => url.split(/[?#]/)[0])
                .replace(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, "[redacted-email]")
                .replace(/[A-Za-z0-9_-]{16,}\.[A-Za-z0-9_-]{16,}\.[A-Za-z0-9_-]{8,}/g, "[redacted-token]")
                .slice(0, limit);
            const attributes = (values) => JSON.stringify(values);
            // Dynamic deep-link identifiers can be user-controlled. Keep route metrics useful
            // without allowing challenge codes, game ids, or pack ids into telemetry.
            const normalizedRoute = () => {
                const segments = String(location.pathname || "/").split("/").filter(Boolean);
                const dynamicRoute = segments[0];
                const routeParameter = { c: ":code", duel: ":code", game: ":id", pack: ":id" };
                if (Object.prototype.hasOwnProperty.call(routeParameter, dynamicRoute)) {
                    return segments.length > 1
                        ? "/" + dynamicRoute + "/" + routeParameter[dynamicRoute]
                        : "/" + dynamicRoute;
                }
                return "/" + segments.join("/");
            };
            const reportCrash = (name, message, stack) => {
                if (!limited("crash", 20)) crash(name, cleanText(message, 320), cleanText(stack, 900));
            };
            const onError = (event) => reportCrash(
                "browser_error",
                event && event.message ? event.message : "Browser error",
                event && event.error && event.error.stack ? event.error.stack : "",
            );
            const onRejection = (event) => {
                const reason = event && event.reason;
                reportCrash(
                    "unhandled_promise_rejection",
                    reason && reason.message ? reason.message : String(reason || "Unhandled promise rejection"),
                    reason && reason.stack ? reason.stack : "",
                );
            };
            const reportMetric = (name, value, values) => {
                if (Number.isFinite(value) && value >= 0 && !limited("performance", 60)) {
                    metric(name, value, attributes(values));
                }
            };
            const observe = (type, callback) => {
                if (!globalThis.PerformanceObserver) return null;
                try {
                    const observer = new PerformanceObserver((list) => list.getEntries().forEach(callback));
                    observer.observe({ type, buffered: false });
                    return observer;
                } catch (_) {
                    return null;
                }
            };

            const observers = [
                observe("navigation", (entry) => {
                    reportMetric("web_navigation_load", entry.loadEventEnd || entry.duration, {
                        route: normalizedRoute(),
                        navigation_type: String(entry.type || "navigate"),
                    });
                    reportMetric("web_dom_content_loaded", entry.domContentLoadedEventEnd, { route: normalizedRoute() });
                }),
                observe("paint", (entry) => reportMetric("web_" + entry.name.replaceAll("-", "_"), entry.startTime, {
                    route: normalizedRoute(),
                })),
                observe("largest-contentful-paint", (entry) => reportMetric("web_largest_contentful_paint", entry.startTime, {
                    route: normalizedRoute(),
                })),
                observe("longtask", (entry) => reportMetric("web_long_task", entry.duration, { route: normalizedRoute() })),
            ].filter(Boolean);

            addEventListener("error", onError);
            addEventListener("unhandledrejection", onRejection);
            addEventListener("pagehide", flush);

            if (Array.isArray(globalThis.__ALOTOKU_EARLY_ERRORS__)) globalThis.__ALOTOKU_EARLY_ERRORS__.length = 0;
            const earlyHandlers = globalThis.__ALOTOKU_EARLY_ERROR_HANDLERS__;
            if (earlyHandlers) {
                removeEventListener("error", earlyHandlers.onError);
                removeEventListener("unhandledrejection", earlyHandlers.onRejection);
                delete globalThis.__ALOTOKU_EARLY_ERROR_HANDLERS__;
            }

            globalThis.__alotokuTelemetryHooks = { onError, onRejection, flush, observers };
        }
        ,
    'com.tvealot.sudoku.analytics.__convertKotlinClosureToJsClosure_3' : (f, trampoline) => getCachedJsObject(f, (p0, p1, p2) => trampoline(f, p0, p1, p2)),
    'com.tvealot.sudoku.analytics.removeBrowserTelemetryHooks' : 
        () => {
            const hooks = globalThis.__alotokuTelemetryHooks;
            if (!hooks) return;
            removeEventListener("error", hooks.onError);
            removeEventListener("unhandledrejection", hooks.onRejection);
            removeEventListener("pagehide", hooks.flush);
            hooks.observers.forEach((observer) => observer.disconnect());
            delete globalThis.__alotokuTelemetryHooks;
        }
        ,
    'com.tvealot.sudoku.analytics.postBrowserTelemetryRequest' : 
        (endpoint, token, payload, success, failure) => {
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 10000);
            fetch(endpoint, {
                signal: controller.signal,
                method: "POST",
                headers: {
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json",
                },
                body: payload,
                credentials: "same-origin",
            }).then((response) => success(response.status)).catch(() => failure()).finally(() => clearTimeout(timeout));
            return controller;
        }
        ,
    'com.tvealot.sudoku.analytics.abortBrowserTelemetryRequest' : (request) => request.abort(),
    'androidx.sqlite.driver.web.fileName_$external_prop_setter' : (_this, v) => _this.fileName = v,
    'androidx.sqlite.driver.web.databaseId_$external_prop_getter' : (_this) => _this.databaseId,
    'androidx.sqlite.driver.web.databaseId_$external_prop_setter' : (_this, v) => _this.databaseId = v,
    'androidx.sqlite.driver.web.sql_$external_prop_setter' : (_this, v) => _this.sql = v,
    'androidx.sqlite.driver.web.statementId_$external_prop_getter' : (_this) => _this.statementId,
    'androidx.sqlite.driver.web.parameterCount_$external_prop_getter' : (_this) => _this.parameterCount,
    'androidx.sqlite.driver.web.columnNames_$external_prop_getter' : (_this) => _this.columnNames,
    'androidx.sqlite.driver.web.statementId_$external_prop_setter' : (_this, v) => _this.statementId = v,
    'androidx.sqlite.driver.web.bindings_$external_prop_setter' : (_this, v) => _this.bindings = v,
    'androidx.sqlite.driver.web.rows_$external_prop_getter' : (_this) => _this.rows,
    'androidx.sqlite.driver.web.columnTypes_$external_prop_getter' : (_this) => _this.columnTypes,
    'androidx.sqlite.driver.web.statementId_$external_prop_setter_1' : (_this, v) => _this.statementId = v,
    'androidx.sqlite.driver.web.databaseId_$external_prop_setter_1' : (_this, v) => _this.databaseId = v,
    'androidx.sqlite.driver.web.cmd_$external_prop_setter' : (_this, v) => _this.cmd = v,
    'androidx.sqlite.driver.web.util.initExternal' : () => ({}),
    'androidx.sqlite.driver.web.worker.id_$external_prop_getter' : (_this) => _this.id,
    'androidx.sqlite.driver.web.worker.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'androidx.sqlite.driver.web.worker.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.sqlite.driver.web.worker.data_$external_prop_setter' : (_this, v) => _this.data = v,
    'androidx.sqlite.driver.web.worker.error_$external_prop_getter' : (_this) => _this.error,
    'androidx.sqlite.driver.web.worker.error_$external_prop_setter' : (_this, v) => _this.error = v,
    'com.tvealot.sudoku.sqlite.wasm.createSharedWorker' : () => (() => {
            const worker = new Worker(new URL("sudoku-sqlite-wasm-worker/worker.js", import.meta.url));
            const channels = new Map();
            let nextChannelId = 0;
            worker.onmessage = (event) => {
                const channel = channels.get(event.data?.channel);
                channel?.onmessage?.(new MessageEvent('message', { data: event.data }));
            };
            worker.onerror = (event) => {
                for (const channel of channels.values()) channel.onerror?.(event);
            };
            return {
                openChannel() {
                    const channelId = nextChannelId++;
                    const channel = {
                        onmessage: null,
                        onerror: null,
                        postMessage(message) {
                            message.channel = channelId;
                            worker.postMessage(message);
                        },
                    };
                    channels.set(channelId, channel);
                    return channel;
                },
            };
        })(),
    'com.tvealot.sudoku.sqlite.wasm.openChannel' : (sharedWorker) => sharedWorker.openChannel(),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.loadBuffer' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:buffer') : null),
    'kotlinx.io.node.loadOs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:os') : null),
    'kotlinx.io.node.loadPath' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:path') : null),
    'kotlinx.io.node.loadFs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:fs') : null),
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'com.tvealot.authorization.data.readOrCreateIdentity' : 
        (generate, success, failure) => {
            let done = false;
            const fail = () => { if (!done) { done = true; failure(); } };
            try {
                const request = indexedDB.open('sudoku.local-identity.v1', 1);
                request.onupgradeneeded = () => request.result.createObjectStore('identity');
                request.onerror = fail;
                request.onblocked = fail;
                request.onsuccess = () => {
                    const db = request.result;
                    if (done) { db.close(); return; }
                    try {
                    db.onversionchange = () => db.close();
                    const tx = db.transaction('identity', 'readwrite');
                    const store = tx.objectStore('identity');
                    let value;
                    tx.onabort = () => { db.close(); fail(); };
                    tx.onerror = fail;
                    tx.oncomplete = () => {
                        db.close();
                        if (!done) { done = true; success(value); }
                    };
                    const read = store.get('installation-id');
                    read.onsuccess = () => {
                        try {
                            value = read.result;
                            if (value === undefined) {
                                value = generate();
                                store.add(value, 'installation-id');
                            }
                        } catch (_) { tx.abort(); }
                    };
                    } catch (_) { db.close(); fail(); }
                };
            } catch (_) { fail(); }
        }
        ,
    'com.tvealot.authorization.data.randomInstallationUuid' : () => crypto.randomUUID(),
    'com.tvealot.authorization.ui.confirmBrowserProgressMigration' : 
        () => window.confirm(
            "Keep this browser's local progress and merge it into the Google account? " +
            "Choose Cancel to sign in without uploading local progress.",
        )
        ,
    'com.tvealot.authorization.ui.configuredGoogleWebClientId' : 
        () => {
            const candidates = [
                globalThis.ALOTOKU_GOOGLE_CLIENT_ID,
                globalThis.__ALOTOKU_CONFIG__ && globalThis.__ALOTOKU_CONFIG__.googleClientId,
                document.querySelector('meta[name="google-signin-client_id"]')?.content,
                document.querySelector('meta[name="alotoku-google-client-id"]')?.content,
            ];
            const value = candidates.find((candidate) => {
                return typeof candidate === "string" && candidate.trim().length > 0;
            });
            return value ? value.trim() : "";
        }
        ,
    'com.tvealot.authorization.ui.startGoogleSignInRedirect' : 
        (clientId, storageKey, preserveData, failure) => {
            try {
                const bytesToBase64Url = (bytes) => {
                    let value = "";
                    bytes.forEach((byte) => {
                        value += String.fromCharCode(byte);
                    });
                    return btoa(value)
                        .replaceAll("+", "-")
                        .replaceAll("/", "_")
                        .replaceAll("=", "");
                };
                const randomValue = () => {
                    const bytes = new Uint8Array(24);
                    crypto.getRandomValues(bytes);
                    return bytesToBase64Url(bytes);
                };
                const state = randomValue();
                const nonce = randomValue();
                const returnPath = window.location.pathname + window.location.search;
                localStorage.setItem(
                    storageKey,
                    JSON.stringify({
                        state,
                        nonce,
                        returnPath,
                        preserveData,
                        createdAt: Date.now(),
                    }),
                );

                // OAuth clients permit an exact allowlist of callback URIs. The pending returnPath
                // above restores the initiating route after Firebase consumes this root callback.
                const redirectUri = window.location.origin + "/";
                const params = new URLSearchParams({
                    client_id: clientId,
                    redirect_uri: redirectUri,
                    response_type: "id_token",
                    scope: "openid email profile",
                    state,
                    nonce,
                    prompt: "select_account",
                });
                window.location.assign("https://accounts.google.com/o/oauth2/v2/auth?" + params.toString());
            } catch (error) {
                localStorage.removeItem(storageKey);
                const message = error && error.message ? error.message : String(error);
                failure(message);
            }
        }
        ,
    'com.tvealot.sudoku.dailychallenge.data.remote.fetchFirestoreDocument' : 
        (url, success, failure) => {
            fetch(url, { method: "GET" }).then(async (response) => {
                success(response.status, await response.text());
            }).catch((error) => {
                failure(error && error.message ? error.message : String(error));
            });
        }
        ,
    'com.tvealot.sudoku.duelchallenge.data.browserHasPeerConnection' : () => typeof RTCPeerConnection !== 'undefined',
    'com.tvealot.sudoku.duelchallenge.data.browserPeerOffer' : 
        (peer, gatherTimeoutMs, done, fail) => {
            peer.wire(peer.pc.createDataChannel("duel", { ordered: true }));
            peer.pc.createOffer()
                .then((offer) => peer.pc.setLocalDescription(offer))
                .then(() => peer.gathered(gatherTimeoutMs))
                .then(() => done(peer.pc.localDescription.sdp))
                .catch((error) => fail(String(error)));
        }
        ,
    'com.tvealot.sudoku.duelchallenge.data.browserPeerAnswer' : 
        (peer, remoteOffer, gatherTimeoutMs, done, fail) => {
            peer.pc.setRemoteDescription({ type: "offer", sdp: remoteOffer })
                .then(() => peer.pc.createAnswer())
                .then((answer) => peer.pc.setLocalDescription(answer))
                .then(() => peer.gathered(gatherTimeoutMs))
                .then(() => done(peer.pc.localDescription.sdp))
                .catch((error) => fail(String(error)));
        }
        ,
    'com.tvealot.sudoku.duelchallenge.data.browserPeerCreate' : 
        (iceServers, onOpen, onClose, onMessage) => {
            const pc = new RTCPeerConnection({ iceServers: JSON.parse(iceServers) });
            const peer = { pc, dc: null, closed: false };
            const close = () => {
                if (!peer.closed) {
                    peer.closed = true;
                    onClose();
                }
            };
            peer.wire = (dc) => {
                peer.dc = dc;
                dc.onopen = () => { if (!peer.closed) onOpen(); };
                dc.onclose = close;
                // Protocol messages are a few dozen characters; anything long or binary is not ours.
                dc.onmessage = (event) => {
                    if (typeof event.data === "string" && event.data.length <= 256) onMessage(event.data);
                };
            };
            pc.ondatachannel = (event) => peer.wire(event.channel);
            pc.onconnectionstatechange = () => {
                if (pc.connectionState === "failed" || pc.connectionState === "closed") close();
            };
            peer.gathered = (timeoutMs) => new Promise((resolve) => {
                if (pc.iceGatheringState === "complete") return resolve();
                const timer = setTimeout(resolve, timeoutMs);
                pc.addEventListener("icegatheringstatechange", () => {
                    if (pc.iceGatheringState === "complete") {
                        clearTimeout(timer);
                        resolve();
                    }
                });
            });
            return peer;
        }
        ,
    'com.tvealot.sudoku.duelchallenge.data.browserPeerAccept' : 
        (peer, remoteAnswer, done, fail) => {
            peer.pc.setRemoteDescription({ type: "answer", sdp: remoteAnswer })
                .then(() => done())
                .catch((error) => fail(String(error)));
        }
        ,
    'com.tvealot.sudoku.duelchallenge.data.browserPeerSend' : 
        (peer, message) => {
            try {
                if (peer.dc && peer.dc.readyState === "open") {
                    peer.dc.send(message);
                    return true;
                }
            } catch (error) {}
            return false;
        }
        ,
    'com.tvealot.sudoku.duelchallenge.data.browserPeerClose' : 
        (peer) => {
            peer.closed = true;
            try { if (peer.dc) peer.dc.close(); } catch (error) {}
            try { peer.pc.close(); } catch (error) {}
        }
        ,
    'com.tvealot.sudoku.packs.data.catalog.encodeUriComponent' : (value) => encodeURIComponent(value),
    'com.tvealot.sudoku.packs.data.catalog.fetchFirestore' : 
        (url, success, failure) => {
            fetch(url, { method: "GET" }).then(async (response) => {
                success(response.status, await response.text());
            }).catch((error) => {
                failure(error && error.message ? error.message : String(error));
            });
        }
        ,
    'com.tvealot.sudoku.pushnotifications.platform.restoreBrowserNotificationSchedules' : 
        () => {
            const storageKey = "sudoku.browser.pending-notifications.v1";
            const timerStoreKey = "__sudokuBrowserNotificationTimers";
            if (!globalThis.__sudokuScheduleBrowserNotification) {
                globalThis.__sudokuScheduleBrowserNotification = (entry, persistedKey, timersKey) => {
                    const timers = globalThis[timersKey] || (globalThis[timersKey] = {});
                    if (timers[entry.type]) clearTimeout(timers[entry.type]);
                    const maxDelay = 2147483647;
                    const run = () => {
                        const remaining = entry.scheduledAt - Date.now();
                        if (remaining > 0) {
                            timers[entry.type] = setTimeout(run, Math.min(remaining, maxDelay));
                            return;
                        }
                        delete timers[entry.type];
                        try {
                            const all = JSON.parse(localStorage.getItem(persistedKey) || "[]");
                            localStorage.setItem(persistedKey, JSON.stringify(all.filter((item) => item && item.type !== entry.type)));
                        } catch (_) {}
                        if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
                        const options = { body: entry.body || undefined, data: { deepLink: entry.deepLink || "" } };
                        const showDirect = () => {
                            try {
                                const notification = new Notification(entry.title || "Sudoku", options);
                                if (entry.deepLink) notification.onclick = () => window.location.assign(entry.deepLink);
                            } catch (_) {
                                // Mobile browsers require ServiceWorkerRegistration.showNotification.
                            }
                        };
                        if (navigator.serviceWorker && navigator.serviceWorker.getRegistration) {
                            navigator.serviceWorker.getRegistration().then((registration) => {
                                if (registration && registration.active && registration.showNotification) {
                                    registration.showNotification(entry.title || "Sudoku", options).catch(showDirect);
                                } else showDirect();
                            }).catch(showDirect);
                        } else showDirect();
                    };
                    run();
                };
            }
            let entries = [];
            try {
                const stored = JSON.parse(localStorage.getItem(storageKey) || "[]");
                entries = Array.isArray(stored) ? stored : [];
            } catch (_) {}
            const future = entries.filter((entry) => entry && Number(entry.scheduledAt) > Date.now());
            try { localStorage.setItem(storageKey, JSON.stringify(future)); } catch (_) {}
            future.forEach((entry) => globalThis.__sudokuScheduleBrowserNotification(entry, storageKey, timerStoreKey));
        }
        ,
    'com.tvealot.sudoku.pushnotifications.platform.browserPermissionStatus' : 
        () => {
            if (typeof Notification === "undefined") return "denied";
            return Notification.permission || "default";
        }
        ,
    'com.tvealot.sudoku.pushnotifications.platform.requestBrowserNotificationPermission' : 
        (complete) => {
            if (typeof Notification === "undefined" || !Notification.requestPermission) {
                complete("denied");
                return;
            }
            Notification.requestPermission().then(complete).catch(() => complete("denied"));
        }
        ,
    'com.tvealot.sudoku.pushnotifications.platform.scheduleBrowserNotification' : 
        (id, type, title, body, scheduledAtMillis, deepLink) => {
            const storageKey = "sudoku.browser.pending-notifications.v1";
            const timerStoreKey = "__sudokuBrowserNotificationTimers";
            const now = Date.now();
            const scheduledAt = Number(scheduledAtMillis);
            if (!Number.isFinite(scheduledAt) || scheduledAt <= now) return;

            const read = () => {
                try {
                    const value = JSON.parse(localStorage.getItem(storageKey) || "[]");
                    return Array.isArray(value) ? value : [];
                } catch (_) {
                    return [];
                }
            };
            const write = (entries) => localStorage.setItem(storageKey, JSON.stringify(entries));
            const entry = { id, type, title, body, scheduledAt, deepLink };
            const entries = read().filter((item) => item && item.type !== type);
            entries.push(entry);
            write(entries);
            globalThis.__sudokuScheduleBrowserNotification(entry, storageKey, timerStoreKey);
        }
        ,
    'com.tvealot.sudoku.pushnotifications.platform.browserNotificationDeepLink' : 
        (deepLink) => {
            const value = String(deepLink || "").trim();
            if (!value) return "";
            if (value === "sudoku://daily-challenge") return window.location.origin + "/daily-challenge";
            if (value.startsWith("sudoku://game/")) {
                const gameId = value.slice("sudoku://game/".length).split(/[/?#]/)[0];
                return /^\d+$/.test(gameId) ? window.location.origin + "/game/" + gameId : "";
            }
            try {
                const parsed = new URL(value, window.location.origin);
                return parsed.origin === window.location.origin ? parsed.href : "";
            } catch (_) {
                return "";
            }
        }
        ,
    'com.tvealot.sudoku.pushnotifications.platform.cancelBrowserNotification' : 
        (type) => {
            const storageKey = "sudoku.browser.pending-notifications.v1";
            const timers = globalThis.__sudokuBrowserNotificationTimers || {};
            if (timers[type]) clearTimeout(timers[type]);
            delete timers[type];
            try {
                const entries = JSON.parse(localStorage.getItem(storageKey) || "[]");
                localStorage.setItem(storageKey, JSON.stringify((Array.isArray(entries) ? entries : []).filter((entry) => entry && entry.type !== type)));
            } catch (_) {}
        }
        ,
    'com.tvealot.sudoku.pushnotifications.platform.showBrowserNotificationSettingsHint' : 
        () => {
            window.alert("To change Sudoku notifications, use this browser's site settings for notifications.");
        }
        ,
    'com.tvealot.sudoku.ui.acquireLiveRegion' : () => {
        const state = globalThis.__ALOTOKU_LIVE_REGION__ ??= { users: 0, element: null, timer: 0 };
        state.users += 1;
        if (state.element) return;
        const region = document.createElement('div');
        region.id = 'alotoku-live-region';
        region.setAttribute('role', 'status');
        region.setAttribute('aria-live', 'polite');
        region.setAttribute('aria-atomic', 'true');
        region.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;' +
            'overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;';
        document.body.appendChild(region);
        state.element = region;
    },
    'com.tvealot.sudoku.ui.releaseLiveRegion' : () => {
        const state = globalThis.__ALOTOKU_LIVE_REGION__;
        if (!state || state.users === 0) return;
        state.users -= 1;
        if (state.users > 0) return;
        clearTimeout(state.timer);
        state.element?.remove();
        state.element = null;
    },
    'com.tvealot.sudoku.ui.announceInLiveRegion' : (message) => {
        const state = globalThis.__ALOTOKU_LIVE_REGION__;
        const region = state?.element;
        if (!region) return;
        clearTimeout(state.timer);
        region.textContent = '';
        state.timer = setTimeout(() => { region.textContent = message; }, 50);
    },
    'com.tvealot.sudoku.stories.data.browserStoryOrigin' : () => window.location.origin,
    'com.tvealot.sudoku.stories.data.digestStoryBytes' : 
        (binary, success, failure) => {
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
            crypto.subtle.digest('SHA-256', bytes).then(
                digest => success(Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('')),
                failure
            );
        }
        ,
    'com.tvealot.sudoku.stories.data.readStoryPack' : 
        (key, success, failure) => {
            try {
                const request = indexedDB.open('sudoku.story-packs.v1', 1);
                request.onupgradeneeded = () => request.result.createObjectStore('packs');
                request.onerror = failure;
                request.onblocked = failure;
                request.onsuccess = () => {
                    const db = request.result;
                    const tx = db.transaction('packs', 'readonly');
                    const read = tx.objectStore('packs').get(key);
                    read.onsuccess = () => { success(read.result || ''); db.close(); };
                    read.onerror = () => { db.close(); failure(); };
                };
            } catch (_) { failure(); }
        }
        ,
    'com.tvealot.sudoku.stories.data.writeStoryPack' : 
        (key, encoded, success, failure) => {
            try {
                const request = indexedDB.open('sudoku.story-packs.v1', 1);
                request.onupgradeneeded = () => request.result.createObjectStore('packs');
                request.onerror = failure;
                request.onblocked = failure;
                request.onsuccess = () => {
                    const db = request.result;
                    const tx = db.transaction('packs', 'readwrite');
                    tx.objectStore('packs').put(encoded, key);
                    tx.oncomplete = () => { db.close(); success(); };
                    tx.onerror = () => { db.close(); failure(); };
                };
            } catch (_) { failure(); }
        }
        ,
    'com.tvealot.sudoku.accessibility.platform.browserPrefersReducedMotion' : () => !!globalThis.matchMedia && globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches,
    'com.tvealot.sudoku.ambientmusic.webAmbientInit' : (visibility) => {
        let state = globalThis.__sudokuAmbient;
        if (state) { state.visibility = visibility; return; }
        const Audio = globalThis.AudioContext || globalThis.webkitAudioContext;
        if (!Audio) throw new Error('WebAudio unavailable');
        const ctx = new Audio();
        const master = ctx.createGain(); master.gain.value = 0; master.connect(ctx.destination);
        state = { ctx, master, layers: [], sources: [], volume: 1, token: 0, wantsPlay: false, visibility };
        globalThis.__sudokuAmbient = state;
        document.addEventListener('visibilitychange', () => {
          const hidden = document.hidden;
          state.visibility(hidden);
          if (hidden) ctx.suspend(); else if (state.wantsPlay) ctx.resume();
        });
        document.addEventListener('pointerdown', () => { if (state.wantsPlay && !document.hidden) ctx.resume(); });
    },
    'com.tvealot.sudoku.ambientmusic.webAmbientSetVolume' : (volume) => {
        const s = globalThis.__sudokuAmbient; if (!s) return;
        s.volume = volume;
        if (s.wantsPlay) {
          const now = s.ctx.currentTime;
          s.master.gain.cancelScheduledValues(now);
          s.master.gain.setTargetAtTime(volume, now, 0.02);
        }
    },
    'com.tvealot.sudoku.ambientmusic.webAmbientClear' : () => {
        const s = globalThis.__sudokuAmbient; if (!s) return;
        s.token++; s.sources.forEach(x => { try { x.stop(); } catch (_) {} });
        s.sources = []; s.layers = []; s.master.gain.value = 0; s.wantsPlay = false;
    },
    'com.tvealot.sudoku.ambientmusic.webAmbientLoad' : (url, gain, success, failure) => {
        const s = globalThis.__sudokuAmbient;
        fetch(url).then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.arrayBuffer(); })
          .then(bytes => s.ctx.decodeAudioData(bytes))
          .then(buffer => { s.layers.push({ buffer, gain }); success(); }).catch(failure);
    },
    'com.tvealot.sudoku.ambientmusic.webAmbientPlay' : (seconds) => {
        const s = globalThis.__sudokuAmbient; if (!s || document.hidden) return;
        s.token++; s.wantsPlay = true;
        if (!s.sources.length) {
          const at = s.ctx.currentTime + 0.05;
          s.layers.forEach(layer => {
            const source = s.ctx.createBufferSource(); source.buffer = layer.buffer; source.loop = true;
            const volume = s.ctx.createGain(); volume.gain.value = layer.gain;
            source.connect(volume).connect(s.master); source.start(at); s.sources.push(source);
          });
        }
        s.ctx.resume();
        const now = s.ctx.currentTime; s.master.gain.cancelScheduledValues(now);
        s.master.gain.setValueAtTime(s.master.gain.value, now);
        s.master.gain.linearRampToValueAtTime(s.volume, now + seconds);
    },
    'com.tvealot.sudoku.ambientmusic.webAmbientPause' : (seconds) => {
        const s = globalThis.__sudokuAmbient; if (!s) return;
        s.wantsPlay = false;
        const token = ++s.token; const now = s.ctx.currentTime;
        s.master.gain.cancelScheduledValues(now);
        s.master.gain.setValueAtTime(s.master.gain.value, now);
        s.master.gain.linearRampToValueAtTime(0, now + seconds);
        setTimeout(() => { if (s.token === token) s.ctx.suspend(); }, seconds * 1000);
    },
    'com.tvealot.sudoku.ambientmusic.readMusicFile' : (key, success, failure) => {
            const request = indexedDB.open('sudoku.ambient-music.v1', 1);
            request.onupgradeneeded = () => request.result.createObjectStore('files');
            request.onerror = failure; request.onblocked = failure;
            request.onsuccess = () => {
                const db = request.result;
                const read = db.transaction('files', 'readonly').objectStore('files').get(key);
                read.onsuccess = () => { success(read.result || ''); db.close(); };
                read.onerror = () => { db.close(); failure(); };
            };
        },
    'com.tvealot.sudoku.ambientmusic.writeMusicFile' : (key, binary, success, failure) => {
            const request = indexedDB.open('sudoku.ambient-music.v1', 1);
            request.onupgradeneeded = () => request.result.createObjectStore('files');
            request.onerror = failure; request.onblocked = failure;
            request.onsuccess = () => {
                const db = request.result;
                const tx = db.transaction('files', 'readwrite');
                tx.objectStore('files').put(binary, key);
                tx.oncomplete = () => {
                    db.close();
                    const cache = globalThis.__sudokuMusicUrls;
                    if (cache?.has(key)) { URL.revokeObjectURL(cache.get(key)); cache.delete(key); }
                    success();
                };
                tx.onerror = () => { db.close(); failure(); };
            };
        },
    'com.tvealot.sudoku.ambientmusic.musicFileUrl' : (key, success, failure) => {
            const cache = globalThis.__sudokuMusicUrls ||= new Map();
            if (cache.has(key)) { success(cache.get(key)); return; }
            const request = indexedDB.open('sudoku.ambient-music.v1', 1);
            request.onerror = failure; request.onblocked = failure;
            request.onsuccess = () => {
                const db = request.result;
                const read = db.transaction('files', 'readonly').objectStore('files').get(key);
                read.onsuccess = () => {
                    db.close();
                    if (!read.result) { failure(); return; }
                    const bytes = Uint8Array.from(read.result, c => c.charCodeAt(0));
                    const url = URL.createObjectURL(new Blob([bytes], {type:'audio/ogg'}));
                    cache.set(key, url); success(url);
                };
                read.onerror = () => { db.close(); failure(); };
            };
        },
    'com.tvealot.sudoku.ambientmusic.digestMusicBytes' : (binary, success, failure) => {
            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            crypto.subtle.digest('SHA-256', bytes).then(
                hash => success(Array.from(new Uint8Array(hash), b => b.toString(16).padStart(2, '0')).join('')),
                failure);
        },
    'awaitFreeStorageLocks' : (timeoutMs, onFree, onBusy) => {
            if (!navigator.locks || typeof navigator.locks.query !== 'function') { onFree(); return; }
            const deadline = Date.now() + timeoutMs;
            const check = () => navigator.locks.query().then((snapshot) => {
                const busy = (snapshot.held || []).some((lock) => String(lock.name).startsWith('sudoku-sqlite-'));
                if (!busy) { onFree(); return; }
                if (Date.now() >= deadline) { onBusy(); return; }
                setTimeout(check, 100);
            }, () => onFree());
            check();
        },
    'requestSingleTabLock' : (onGranted, onBusy) => {
            if (!navigator.locks) { onGranted(); return; }
            navigator.locks.request('alotoku-app-instance', { ifAvailable: true }, (lock) => {
                if (!lock) { onBusy(); return; }
                onGranted();
                return new Promise(() => {});
            });
        },
    'attachWebGlContextLossReload' : (onBeforeReload) => {
        const reloadKey = 'alotoku.webgl-context-reloaded';
        const reloadCooldownMs = 30000;
        const settleMs = 300;
        let reloading = false;
        const recentlyReloaded = () => {
            try {
                return Date.now() - Number(sessionStorage.getItem(reloadKey) || 0) < reloadCooldownMs;
            } catch (_) {
                return false;
            }
        };
        const reload = () => {
            try { sessionStorage.setItem(reloadKey, String(Date.now())); } catch (_) {}
            location.reload();
        };
        const reloadWhenVisible = () => {
            if (document.visibilityState === 'visible') {
                setTimeout(reload, settleMs);
                return;
            }
            const onVisible = () => {
                if (document.visibilityState !== 'visible') return;
                document.removeEventListener('visibilitychange', onVisible);
                reload();
            };
            document.addEventListener('visibilitychange', onVisible);
        };
        const onContextLost = () => {
            if (reloading || recentlyReloaded()) return;
            reloading = true;
            try { onBeforeReload(); } catch (_) {}
            reloadWhenVisible();
        };
        const watched = new WeakSet();
        const getContext = HTMLCanvasElement.prototype.getContext;
        HTMLCanvasElement.prototype.getContext = function (type, ...rest) {
            const context = getContext.call(this, type, ...rest);
            if (context && String(type).startsWith('webgl') && !watched.has(this)) {
                watched.add(this);
                this.addEventListener('webglcontextlost', onContextLost);
            }
            return context;
        };
    },
    'attachBrowserVisibility' : (callback) => {
        const update = () => callback(document.visibilityState === 'visible');
        document.addEventListener('visibilitychange', update);
        window.addEventListener('pageshow', update);
        window.addEventListener('pagehide', () => callback(false));
        update();
    },
    'com.tvealot.sudoku.postAuthRequest' : 
        (url, body, contentType, success, failure) => {
            fetch(url, {
                signal: AbortSignal.timeout(15000),
                method: "POST",
                headers: { "Content-Type": contentType },
                body,
            }).then(async (response) => {
                const text = await response.text();
                if (!response.ok) {
                    failure(text || response.statusText || ("HTTP " + response.status));
                    return;
                }
                success(text);
            }).catch((error) => {
                failure(error && error.message ? error.message : String(error));
            });
        }
        ,
    'com.tvealot.sudoku.fetchFirestoreDocument' : 
        (method, url, idToken, bodyJson, success, failure) => {
            const toFirestoreValue = (value) => {
                if (value === null || value === undefined) return { nullValue: null };
                if (typeof value === "boolean") return { booleanValue: value };
                if (typeof value === "string") return { stringValue: value };
                if (typeof value === "number") {
                    return Number.isInteger(value)
                        ? { integerValue: String(value) }
                        : { doubleValue: value };
                }
                if (Array.isArray(value)) {
                    return { arrayValue: { values: value.map(toFirestoreValue) } };
                }
                if (typeof value === "object") {
                    return {
                        mapValue: {
                            fields: Object.fromEntries(
                                Object.entries(value).map(([key, child]) => [key, toFirestoreValue(child)]),
                            ),
                        },
                    };
                }
                throw new Error("Unsupported progress value");
            };
            const fromFirestoreValue = (value) => {
                if (!value || "nullValue" in value) return null;
                if ("booleanValue" in value) return value.booleanValue;
                if ("stringValue" in value) return value.stringValue;
                if ("integerValue" in value) return Number(value.integerValue);
                if ("doubleValue" in value) return value.doubleValue;
                if ("arrayValue" in value) {
                    return (value.arrayValue.values || []).map(fromFirestoreValue);
                }
                if ("mapValue" in value) {
                    return Object.fromEntries(
                        Object.entries(value.mapValue.fields || {}).map(
                            ([key, child]) => [key, fromFirestoreValue(child)],
                        ),
                    );
                }
                throw new Error("Unsupported Firestore progress value");
            };
            const options = {
                method,
                headers: {
                    "Accept": "application/json",
                    "Authorization": "Bearer " + idToken,
                },
            };
            if (method === "PATCH") {
                const document = JSON.parse(bodyJson);
                options.headers["Content-Type"] = "application/json";
                options.body = JSON.stringify({
                    fields: Object.fromEntries(
                        Object.entries(document).map(([key, value]) => [key, toFirestoreValue(value)]),
                    ),
                });
            }
            fetch(url, options).then(async (response) => {
                const text = await response.text();
                if (response.status === 404 && (method === "GET" || method === "DELETE")) {
                    success(method === "GET" ? JSON.stringify({ document: null, updateTime: null }) : "");
                    return;
                }
                if (!response.ok) {
                    let firestoreStatus = "";
                    try {
                        const envelope = text ? JSON.parse(text) : null;
                        firestoreStatus = envelope && envelope.error && envelope.error.status
                            ? String(envelope.error.status)
                            : "";
                    } catch (_) {
                        // Only the structured status code crosses the Kotlin boundary.
                    }
                    failure(response.status, firestoreStatus);
                    return;
                }
                if (!text || method !== "GET") {
                    success("");
                    return;
                }
                const firestoreDocument = JSON.parse(text);
                const decoded = Object.fromEntries(
                    Object.entries(firestoreDocument.fields || {}).map(
                        ([key, value]) => [key, fromFirestoreValue(value)],
                    ),
                );
                success(JSON.stringify({
                    document: decoded,
                    updateTime: firestoreDocument.updateTime || null,
                }));
            }).catch((error) => {
                failure(0, "");
            });
        }
        ,
    'com.tvealot.sudoku.fetchFirestoreCollectionList' : 
        (url, idToken, success, failure) => {
            const fromFirestoreValue = (value) => {
                if (!value || "nullValue" in value) return null;
                if ("booleanValue" in value) return value.booleanValue;
                if ("stringValue" in value) return value.stringValue;
                if ("integerValue" in value) return Number(value.integerValue);
                if ("doubleValue" in value) return value.doubleValue;
                if ("arrayValue" in value) {
                    return (value.arrayValue.values || []).map(fromFirestoreValue);
                }
                if ("mapValue" in value) {
                    return Object.fromEntries(
                        Object.entries(value.mapValue.fields || {}).map(
                            ([key, child]) => [key, fromFirestoreValue(child)],
                        ),
                    );
                }
                throw new Error("Unsupported Firestore progress value");
            };
            fetch(url, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Authorization": "Bearer " + idToken,
                },
            }).then(async (response) => {
                const text = await response.text();
                if (response.status === 404) {
                    success(JSON.stringify({ documents: [] }));
                    return;
                }
                if (!response.ok) {
                    let firestoreStatus = "";
                    try {
                        const envelope = text ? JSON.parse(text) : null;
                        firestoreStatus = envelope && envelope.error && envelope.error.status
                            ? String(envelope.error.status)
                            : "";
                    } catch (_) {}
                    failure(response.status, firestoreStatus);
                    return;
                }
                const payload = text ? JSON.parse(text) : { documents: [] };
                const documents = (payload.documents || []).map((entry) => ({
                    document: Object.fromEntries(
                        Object.entries(entry.fields || {}).map(
                            ([key, value]) => [key, fromFirestoreValue(value)],
                        ),
                    ),
                }));
                success(JSON.stringify({ documents }));
            }).catch(() => {
                failure(0, "");
            });
        }
        ,
    'com.tvealot.sudoku.encodeURIComponent' : (value) => encodeURIComponent(value),
    'com.tvealot.sudoku.consumeGoogleSignInRedirectResult' : 
        (storageKey) => {
            const readParams = () => {
                const hash = window.location.hash && window.location.hash.startsWith("#")
                    ? window.location.hash.substring(1)
                    : "";
                const query = window.location.search && window.location.search.startsWith("?")
                    ? window.location.search.substring(1)
                    : "";
                const hashParams = new URLSearchParams(hash);
                const queryParams = new URLSearchParams(query);
                return hashParams.has("id_token") || hashParams.has("error") || hashParams.has("state")
                    ? hashParams
                    : queryParams;
            };
            const decodeJwtPayload = (idToken) => {
                const parts = idToken.split(".");
                if (parts.length < 2) {
                    throw new Error("Google ID token is malformed");
                }
                const base64 = parts[1].replaceAll("-", "+").replaceAll("_", "/");
                const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
                return JSON.parse(atob(padded));
            };
            const cleanUrl = (returnPath) => {
                const fallback = window.location.pathname + window.location.search;
                window.history.replaceState(null, document.title, returnPath || fallback || "/");
                // replaceState does not emit popstate. Notify the WASM deep-link binding so an
                // OAuth return to a challenge/game/pack route is handled after credentials clear.
                window.dispatchEvent(new Event("alotoku-auth-return-path-restored"));
            };

            try {
                const params = readParams();
                const idToken = params.get("id_token") || "";
                const error = params.get("error") || "";
                const state = params.get("state") || "";
                const pendingRaw = localStorage.getItem(storageKey);
                if (!idToken && !error && !state && !pendingRaw) {
                    return "";
                }

                localStorage.removeItem(storageKey);
                const pending = pendingRaw ? JSON.parse(pendingRaw) : null;
                cleanUrl(pending && pending.returnPath);

                if (error) {
                    return JSON.stringify({
                        error: params.get("error_description") || error,
                    });
                }
                if (!idToken) {
                    return "";
                }
                if (!pending) {
                    return JSON.stringify({ error: "Missing Google sign-in redirect state" });
                }
                if (!state || state !== pending.state) {
                    return JSON.stringify({ error: "Google sign-in redirect state mismatch" });
                }
                const payload = decodeJwtPayload(idToken);
                if (pending.nonce && payload.nonce !== pending.nonce) {
                    return JSON.stringify({ error: "Google sign-in redirect nonce mismatch" });
                }
                return JSON.stringify({
                    idToken,
                    preserveData: pending.preserveData === true,
                });
            } catch (error) {
                localStorage.removeItem(storageKey);
                const message = error && error.message ? error.message : String(error);
                return JSON.stringify({ error: message });
            }
        }
        ,
    'com.tvealot.sudoku.data.backend.browser.readDuelMemberToken' : (key) => { try { return sessionStorage.getItem(key); } catch (e) { return null; } },
    'com.tvealot.sudoku.data.backend.browser.writeDuelMemberToken' : (key, value) => { try { sessionStorage.setItem(key, value); } catch (e) {} },
    'com.tvealot.sudoku.data.backend.browser.measurementSecret' : () => btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32)))).replaceAll('+','-').replaceAll('/','_').replaceAll('=',''),
    'com.tvealot.sudoku.data.backend.browser.readPendingPreserveData' : 
        () => {
            const key = "sudoku.own.signin.redirect.v1";
            try {
                const raw = localStorage.getItem(key);
                if (!raw) return false;
                const parsed = JSON.parse(raw);
                return parsed && parsed.preserveData === true;
            } catch (_) {
                return false;
            }
        }
        ,
    'com.tvealot.sudoku.data.backend.browser.clearPendingPreserveData' : 
        () => {
            try { localStorage.removeItem("sudoku.own.signin.redirect.v1"); } catch (_) {}
        }
        ,
    'com.tvealot.sudoku.data.backend.browser.rememberPendingPreserveData' : 
        (preserveData) => {
            try {
                localStorage.setItem(
                    "sudoku.own.signin.redirect.v1",
                    JSON.stringify({ preserveData: preserveData, createdAt: Date.now() }),
                );
            } catch (_) {}
        }
        ,
    'com.tvealot.sudoku.data.backend.browser.redirectToAuthorizationUrl' : 
        (authorizationUrl) => {
            window.location.assign(authorizationUrl);
        }
        ,
    'com.tvealot.sudoku.data.backend.browser.performBrowserOwnFetch' : 
        (url, method, body, memberToken, success, failure) => {
            const headers = {
                "Accept": "application/json",
                "X-Auth-Request": "1",
            };
            if (memberToken) {
                headers["X-Duel-Member-Token"] = memberToken;
            }
            const init = {
                method,
                credentials: "include",
                headers,
            };
            if (body != null) {
                headers["Content-Type"] = "application/json";
                init.body = body;
            }
            fetch(url, init).then(async (response) => {
                const text = await response.text();
                success(response.status, text);
            }).catch((error) => {
                failure(error && error.message ? error.message : String(error));
            });
        }
        ,
    'com.tvealot.sudoku.data.backend.browser.randomRequestId' : () => crypto.randomUUID(),
    'com.tvealot.sudoku.data.backend.browser.readOwnSecureRecord' : 
        (storageKey, success, failure) => {
            const dbName = "sudoku.own-session.v1";
            const storeName = "records";
            try {
                const request = indexedDB.open(dbName, 1);
                request.onupgradeneeded = () => request.result.createObjectStore(storeName);
                request.onerror = () => failure();
                request.onblocked = () => failure();
                request.onsuccess = () => {
                    const db = request.result;
                    try {
                        db.onversionchange = () => db.close();
                        const tx = db.transaction(storeName, "readonly");
                        const store = tx.objectStore(storeName);
                        const read = store.get(storageKey);
                        tx.onerror = () => { db.close(); failure(); };
                        tx.oncomplete = () => db.close();
                        read.onsuccess = () => success(read.result || "");
                        read.onerror = () => failure();
                    } catch (_) { db.close(); failure(); }
                };
            } catch (_) { failure(); }
        }
        ,
    'com.tvealot.sudoku.data.backend.browser.writeOwnSecureRecord' : 
        (storageKey, encoded, success, failure) => {
            const dbName = "sudoku.own-session.v1";
            const storeName = "records";
            try {
                const request = indexedDB.open(dbName, 1);
                request.onupgradeneeded = () => request.result.createObjectStore(storeName);
                request.onerror = () => failure();
                request.onblocked = () => failure();
                request.onsuccess = () => {
                    const db = request.result;
                    try {
                        db.onversionchange = () => db.close();
                        const tx = db.transaction(storeName, "readwrite");
                        const store = tx.objectStore(storeName);
                        store.put(encoded, storageKey);
                        tx.onerror = () => { db.close(); failure(); };
                        tx.oncomplete = () => { db.close(); success(); };
                    } catch (_) { db.close(); failure(); }
                };
            } catch (_) { failure(); }
        }
        ,
    'com.tvealot.sudoku.di.startWorker' : (url, onMessage, onFailure) => {
      if (typeof Worker === 'undefined') return null;
      let worker;
      try { worker = new Worker(url); } catch (error) { console.warn('Generation worker:', error); return null; }
      worker.onmessage = (event) => onMessage(String(event.data));
      worker.onerror = (event) => { event.preventDefault(); onFailure(String(event.message || 'script error')); };
      worker.onmessageerror = () => onFailure('unreadable message');
      return worker;
    },
    'com.tvealot.sudoku.di.postToWorker' : (worker, message) => worker.postMessage(message),
    'com.tvealot.sudoku.di.terminateWorker' : (worker) => worker.terminate(),
    'com.tvealot.sudoku.di.fetchBrowserRemoteConfig' : 
        (url, success, failure) => {
            fetch(url, {
                signal: AbortSignal.timeout(15000),
                method: "GET",
                headers: {
                    "Accept": "application/json",
                },
            }).then(async (response) => {
                const text = await response.text();
                if (!response.ok) {
                    failure(text || response.statusText || ("HTTP " + response.status));
                    return;
                }
                success(text);
            }).catch((error) => {
                failure(error && error.message ? error.message : String(error));
            });
        }
        ,
    'com.tvealot.sudoku.platform.browserNotificationSettingsSupported' : 
        () => globalThis.isSecureContext === true &&
            typeof globalThis.Notification !== "undefined" &&
            typeof globalThis.Notification.requestPermission === "function"
        ,
    'com.tvealot.sudoku.platform.openBrowserExternalUrl' : 
        (url) => {
            const target = String(url || "").trim();
            if (!target) return;

            let parsed;
            try {
                parsed = new URL(target, window.location.href);
            } catch (_) {
                return;
            }
            if (!["https:", "http:", "mailto:"].includes(parsed.protocol)) return;

            // An anchor click preserves browser popup policy without treating the `window.open`
            // return value as a signal to navigate the current app tab.
            const anchor = document.createElement("a");
            anchor.href = parsed.href;
            anchor.target = "_blank";
            anchor.rel = "noopener noreferrer";
            anchor.referrerPolicy = "no-referrer";
            anchor.style.display = "none";
            (document.body || document.documentElement).appendChild(anchor);
            anchor.click();
            anchor.remove();
        }
        ,
    'com.tvealot.sudoku.platform.shareBrowserText' : 
        (text) => {
            const value = String(text || "");
            if (!value) return;

            const copy = () => {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(value).catch(() => window.prompt("Copy this Sudoku challenge:", value));
                } else {
                    window.prompt("Copy this Sudoku challenge:", value);
                }
            };

            if (navigator.share) {
                navigator.share({ title: "Sudoku challenge", text: value }).catch((error) => {
                    if (!error || error.name !== "AbortError") copy();
                });
                return;
            }
            copy();
        }
        ,
    'com.tvealot.sudoku.ui.stampStartupFrame' : (stage) => {
            const startup = globalThis.__ALOTOKU_STARTUP__;
            if (!startup || startup.ready) return;
            startup.stage = stage;
            startup.frameAt = performance.now();
        },
    'com.tvealot.sudoku.ui.markStartupReady' : () => {
            const startup = globalThis.__ALOTOKU_STARTUP__;
            if (!startup) return;
            startup.stage = "Ready";
            startup.ready = true;
        },
    'com.tvealot.sudoku.ui.setBrowserThemeColor' : (color) => {
        document.querySelectorAll('meta[name="theme-color"]').forEach((meta) => meta.setAttribute('content', color));
        document.documentElement.style.backgroundColor = color;
        document.body.style.backgroundColor = color;
    },
    'com.tvealot.sudoku.webinstall.browserInstallKind' : () => {
        const state = globalThis.__ALOTOKU_INSTALL__ || {};
        const standalone = (typeof globalThis.matchMedia === 'function' && matchMedia('(display-mode: standalone)').matches)
          || navigator.standalone === true;
        if (standalone || state.installed) return 'installed';
        // A used or dismissed event still means this browser installs; Chrome sends a fresh one later.
        if (state.prompt || state.promptSeen) return 'prompt';
        const ua = navigator.userAgent || '';
        if (/FBAN|FBAV|Instagram|Telegram|Line\//.test(ua)) return 'unsupported';
        const ios = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        if (ios) return /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua) ? 'ios_safari' : 'unsupported';
        if (/Macintosh/.test(ua) && /Version\/(1[7-9]|[2-9]\d)/.test(ua) && /Safari/.test(ua) && !/Chrome|Chromium|Edg/.test(ua)) return 'mac_safari';
        if (/Android/.test(ua) && /Firefox/.test(ua)) return 'firefox_android';
        return 'unsupported';
    },
    'com.tvealot.sudoku.webinstall.subscribeToInstallEvents' : (callback) => {
        const state = globalThis.__ALOTOKU_INSTALL__;
        if (state) state.listeners.push(() => callback());
    },
    'com.tvealot.sudoku.webinstall.showInstallPrompt' : (callback) => {
        const state = globalThis.__ALOTOKU_INSTALL__;
        const event = state && state.prompt;
        if (!event) { callback('unavailable'); return; }
        state.prompt = null;
        event.prompt();
        event.userChoice
          .then((choice) => callback(choice.outcome === 'accepted' ? 'accepted' : 'dismissed'))
          .catch(() => callback('unavailable'));
    }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    